<template>
    
    <div class="filter"> 
        
        <label for="filterFrom">
            <slot>Émise</slot>    
        </label>

        <Datepicker
            id="filterFrom"
            :language="datepickerLocale"
            :monday-first="datepickerMondayFirst"
            :disabled-dates="disabledDatesFrom"
            v-model="value.from"
            placeholder="après le"
            @input="fireChange" />

        <label for="filterTo">&mdash;</label>
        <Datepicker
            id="filterTo"
            :language="datepickerLocale"
            :monday-first="datepickerMondayFirst"
            :disabled-dates="disabledDatesTo"
            v-model="value.to"
            placeholder="avant le"
            @input="fireChange" />
    </div>

</template>

<script>
import Datepicker from 'vuejs-datepicker'
import * as DATEPICKER_LOCALES from "vuejs-datepicker/src/locale"

export default {

    props: {

        value: {
            type: Object,
            default: () => {
                return {
                    from: null,
                    to: null
                }
            }
        },
    },

    data: function() {
        return {
            datepickerLocale: DATEPICKER_LOCALES['fr'],
            datepickerMondayFirst: true
        }
    },

    computed: {

        disabledDatesFrom: function() {

            return {
                from: (this.value.to) ? this.value.to : new Date()
            }
        },

        disabledDatesTo: function() {

            return {
                from: new Date(),
                to: (this.value.from) ? this.value.from : null
            }
        },
    },
    
    methods: {

        fireChange: function() {

            const value = {
                from: this.value.from,
                to: this.value.to
            }

            this.$emit('selected', value)
            this.$emit('input', value)
        }
    },

    components: {
        Datepicker
    }
}

</script>